/*
		repr.js,
			Support for repr() function to stringify supported objects in such a way that they can be unrepr'd.

 */


module.exports = repr;

var b = require('./base.js');
var str = require('./str.js');

Object.extend(String.prototype, {
	__repr__: function() {
		return '"' + this.replace(/\\/g, '\\\\').replace(/"/g, '\\\"').replace(/\r/g, "\\r").replace(/\n/g, "\\n") + '"';
	},

	format: function() {
		var idx = 0, toidx;
		var argidx = 0, fmt;
		var result = '';
		while(true) {
			toidx = this.indexOf('%', idx);
			if(toidx < 0) {
				break;		/* we're done */
			}
			result += this.substring(idx, toidx);		/* grab non-format chars */
			fmt = this[toidx + 1];
			switch(fmt) {
				case '%':
					result += '%';
				break;
				case 's':
					result += str(arguments[argidx++]);
				break;
				case 'r':
					result += repr(arguments[argidx++]);
				break;
			}
			idx = toidx + 2;
		}
		result += this.substring(idx);		/* add trailing non-format chars */
		return result;
	}
});

/* objects that we want to toString */
Number.prototype.__repr__ = Number.prototype.toString;
Boolean.prototype.__repr__ = Boolean.prototype.toString;

Object.optextend(Array.prototype, {
	max: function() {
		var highest = this[0];
		for(var i = 1; i < this.length; i++) {
			if(this[i] > highest) {
				highest = this[i];
			}
		}
		return highest;
	},

	min: function() {		/* XXX: these three functions shouldn't be here (min, max, indexOf) base? */
		var lowest = this[0];
		for(var i = 1; i < this.length; i++) {
			if(this[i] < lowest) {
				lowest = this[i];
			}
		}
		return lowest;
	},

	indexOf: function(elem) {
		for(var i = 0; i < this.length; i++) {
			if(this[i] == elem) {
				return i;
			}
		}
		return -1;
	},

	extend: function(other) {
		for(var i = 0; i < other.length; i++) {
			this.push(other[i]);
		}
	},

	__repr__: function() {
		var ret = "[";
		for(var i = 0; i < this.length; i++) {
			if(i != 0) {
				ret += ",";
			}
			ret += repr(this[i]);
		}
		ret += "]";
		return ret;
	}
});

function dump(obj) {
	var ret = '{';
	var first = true;
	for(var key in obj) {
		if(first) {
			first = false;
		}
		else {
			ret += ', ';
		}
		ret += repr(key) + ': ' + repr(obj[key]);
	}
	ret += '}';
	return ret;
}

function repr(obj) {
	if(obj === undefined) {
		return 'undefined';
	}
	else if(obj == null) {
		return 'null';
	}
	else if(obj.__repr__) {
		return obj.__repr__();
	}
	return dump(obj);
}

function unrepr(s) {
	try {
		return eval('(' + s + ')');
	}
	catch(err) {
		return null;
	}
}

function str(obj) {
	if(obj === undefined) {
		return '';
	}
	else if(obj == null) {
		return '';
	}
	else if(obj.toString) {
		return obj.toString();
	}
	else {
		return repr(obj);
	}
}

